import React from 'react'
import Layout from "../components/Layout"
import Services from "../components/Services"

const ServicesPage = () => {
    return (
        <Layout 
            title="Our Services"
            subtitle="Find out what Shopify Systems can provide for you"        
        >
            <Services />
        </Layout>
    )
}

export default ServicesPage
